<template>
  <div
    class="detail-pop"
    id="moveLandInfo"
    :style="{ width: popWidth, height: popHeight }"
  >
    <div class="detail-pop-header">
      <div class="detail-pop-header-title">
        <div :class="type == 1 ? 'active-border' : ''">用地详情</div>
      </div>
      <div class="detail-pop-header-close" @click="onClose">
        <i class="el-icon-close" style="font-size: 20px"></i>
      </div>
      <div
        class="detail-pop-header-rank"
        @mousedown.stop="dragDiv($event)"
        @mouseup.stop="clearEvent($event)"
      >
        <!-- <i class="el-icon-rank"></i> -->
      </div>
    </div>
    <div class="detail-pop-center scrollbar-definition">
      <div class="detail-pop-content">
        <div class="detail-pop-content-title">
          <div class="yuan"></div>
          基本信息
        </div>
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">宗地编号:</el-col>
              <el-col :span="18">{{ info.code }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">标签:</el-col>
              <el-col :span="18">
                <span v-for="(item, lIndex) in info.labels" :key="lIndex"
                  >{{ item.labelName }}&nbsp;&nbsp;</span
                ></el-col
              >
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">土地用途:</el-col>
              <el-col :span="18">{{ info.typeName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">用地面积:</el-col>
              <el-col :span="18">{{ info.area }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">出让年限:</el-col>
              <el-col :span="18">{{ info.transferDate }}年</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">土地来源:</el-col>
              <el-col :span="18">{{ info.statusName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">行政区划:</el-col>
              <el-col :span="18">{{ info.countyName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="8">现状土地条件：</el-col>
              <el-col :span="16">{{ info.infrastructureName }}</el-col>
            </el-col>
            <!--            <el-col :span="12" class="detail-pop-content-box-col">-->
            <!--              <el-col :span="6">供应期限：</el-col>-->
            <!--              <el-col :span="18">{{ gyqx[info.supplyPeriod - 1] }}</el-col>-->
            <!--            </el-col>-->
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">立等可供</el-col>
              <el-col :span="18">{{ gyqx[info.supplyPeriod - 1] }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="3">土地坐落：</el-col>
              <el-col :span="21">{{ info.location }}</el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="detail-pop-content">
        <div class="detail-pop-content-title">
          <div class="yuan"></div>
          规划条件
        </div>
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">容积率：</el-col>
              <el-col :span="18"> {{ info.plotRate }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">绿化率：</el-col>
              <el-col :span="18">{{ info.greeningRate }}%</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">建筑密度:</el-col>
              <el-col :span="18">{{ info.buildingDensity }}%</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">建筑限高:</el-col>
              <el-col :span="18">{{ info.buildingHeight }}米</el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="detail-pop-content">
        <div class="detail-pop-content-title">
          <div class="yuan"></div>
          地块招商信息
        </div>
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">行业分类：</el-col>
              <el-col :span="18"> {{ info.industryTypeName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">项目名称：</el-col>
              <el-col :span="18">{{ info.project }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">参考价格:</el-col>
              <el-col :span="18">{{ info.price }}万元</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">用地联系人:</el-col>
              <el-col :span="18">{{ info.person }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="6">联系方式:</el-col>
              <el-col :span="18">{{ info.phone }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="3">宣传图片:</el-col>
              <el-col :span="21">
                <div class="img-list-box">
                  <div
                    class="img-list"
                    v-for="(item, index) in files.pronounceImages"
                    :key="index"
                    @click="handleLook(files.pronounceImages, index)"
                  >
                    <img :src="item.url" alt="" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="3">相关附件:</el-col>
              <el-col :span="21">
                <div class="img-list-box">
                  <div
                    class="img-list"
                    v-for="(item, index) in files.pronounceFiles"
                    :key="index"
                    v-show="files.pronounceFiles.length > 0"
                    @click="lookPdf(item)"
                  >
                    <img
                      src="../../../assets/images/common/pdf.png"
                      v-show="item.suffix == 'pdf'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/word.png"
                      v-show="item.suffix == 'docx' || item.suffix == 'doc'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/excel.png"
                      v-show="item.suffix == 'xlsx' || item.suffix == 'xls'"
                      alt=""
                    />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="3">宣传视频:</el-col>
              <el-col :span="21">
                <div class="img-list-box">
                  <div
                    class="img-list1"
                    v-for="(item, index) in files.pronounceVideos"
                    :key="index"
                  >
                    <img :src="item.thumbnailSrc" alt="" />
                    <div class="mask">
                      <div
                        class="iconfont icon-bofang"
                        @click="playVideos(item)"
                      ></div>
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="3">证明材料:</el-col>
              <el-col :span="21">
                <div class="img-list-box">
                  <div
                    class="img-list1"
                    v-for="(item, index) in files.pronounceApproval"
                    v-show="item.suffix == 'mp4'"
                    :key="index"
                  >
                    <img :src="serveImgUrl + item.thumbnail" alt="" />
                    <div class="mask">
                      <div
                        class="iconfont icon-bofang"
                        @click="playVideos(item)"
                      ></div>
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="img-list"
                    v-for="(item, index) in files.pronounceApproval"
                    v-show="item.suffix == 'png' || item.suffix == 'jpg'"
                    :key="index"
                  >
                    <img :src="item.url" alt="" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                  <div
                    class="img-list"
                    v-for="(item, index) in files.pronounceApproval"
                    :key="index"
                    v-show="
                      item.suffix == 'pdf' ||
                      item.suffix == 'docx' ||
                      item.suffix == 'doc' ||
                      item.suffix == 'xlsx' ||
                      item.suffix == 'xls'
                    "
                    @click="lookPdf(item)"
                  >
                    <img
                      src="../../../assets/images/common/pdf.png"
                      v-show="item.suffix == 'pdf'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/word.png"
                      v-show="item.suffix == 'docx' || item.suffix == 'doc'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/excel.png"
                      v-show="item.suffix == 'xlsx' || item.suffix == 'xls'"
                      alt=""
                    />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <video-image
      :visible="dialogVisible"
      :imageSrc="dialogImageUrl"
      @onCloseImage="onCloseImage"
    ></video-image>
    <video-dialog
      :visible="dialogVisibleVideo"
      :videoSrc="videoSrc"
      :videoTitle="videoTitle"
      @onCloseVideo="onCloseVideo"
    ></video-dialog>

    <el-image-viewer
      :url-list="srcList"
      :initial-index="viewerIndex"
      :on-close="closeViewer"
      v-if="viewerShow"
      style="z-index: 9999"
    ></el-image-viewer>
  </div>
</template>
<script>
import VideoDialog from "@/components/currency/videoDialog";
import VideoImage from "@/components/currency/videoImage";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "land-detail-pop",
  components: {
    VideoDialog,
    VideoImage,
    ElImageViewer,
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    popHeight: {
      type: String,
      default: "600px",
    },
    popWidth: {
      type: String,
      default: "800px",
    },
    colProportion: {
      type: Number,
      default: 12,
    },
    labelProportion: {
      type: Number,
      default: 6,
    },
    valueProportion: {
      type: Number,
      default: 18,
    },
    //详情数据
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //文件
    files: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      gyqx: ["立等可供", "近期可供", "计划可供"],
      dialogVisibleVideo: false,
      videoSrc: "",
      videoTitle: "",
      dialogImageUrl: "",
      dialogVisible: false,
      type: 1,
      viewerShow: false,
      srcList: [],
      viewerIndex: 0,
      serveImgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  mounted() {},
  methods: {
    // 区块拖动
    dragDiv(el, index) {
      let osmall = document.getElementById("moveLandInfo");

      // 用于保存小的div拖拽前的坐标
      osmall.startX = el.clientX - osmall.offsetLeft;
      osmall.startY = el.clientY - osmall.offsetTop;
      document.onmousemove = (e) => {
        let left, top;
        left = e.clientX - osmall.startX;
        top = e.clientY - osmall.startY;
        osmall.style.left = left + "px";
        osmall.style.top = top + "px";
        // coordinate.x = left;
        // coordinate.y = top;
        if (left <= 0) {
          osmall.style.left = 0 + "px";
          // coordinate.x = 0;
        }
        if (top <= 0) {
          osmall.style.top = 0 + "px";
          // coordinate.y = 0;
        }
      };
    },
    // 清除鼠标事件
    clearEvent() {
      document.onmousemove = null;
      document.onmouseup = null;
    },
    onClose() {
      this.$emit("onCloseLand", false);
    },
    //播放视频
    playVideos(file) {
      this.dialogVisibleVideo = true;
      this.videoSrc =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.videoTitle = file.fileTitle || "";
    },
    onCloseVideo() {
      this.dialogVisibleVideo = false;
    },
    onCloseImage() {
      this.dialogVisible = false;
    },
    lookPdf(file) {
      window.open(systemConfig.imgServer + systemConfig.imgApi + file.filePath);
    },
    //查看图片
    handleLook(list, index) {
      this.srcList = [];
      list.forEach((item) => {
        this.srcList.push(item.url);
      });
      this.viewerIndex = index;
      this.viewerShow = true;
    },
    //关闭查看大图
    closeViewer() {
      this.viewerShow = false;
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/common.css";
.detail-pop {
  background: #fff;
  border: 1px solid rgb(153, 153, 153);
  resize: both;
  overflow: auto;
}
.detail-pop-header-rank {
  position: absolute;
  top: 8px;
  left: 240px;
  width: 50%;
  height: 41px;
  /* text-align: center;
  color: #808080;
  font-weight: 600;
  font-size: 0.95rem; */
  cursor: pointer;
}
.detail-pop-header {
  color: #808080;
  font-size: 1rem;
  padding: 7px 16px;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.detail-pop-header-title {
  width: 100%;
  display: flex;
  /* padding: 0 20px; */
  border-bottom: 1px solid rgb(206, 206, 206);
}
.detail-pop-header-title > div {
  margin: 0 10px;
  padding-top: 10px;
  padding-bottom: 7px;
}
.active-border {
  color: #157cf3;
  border-bottom: 2px solid #157cf3;
}
.detail-pop-header-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 26px;
  height: 26px;
  /* background: rgb(89 197 222 / 62%);
  border-radius: 0 0 0 50px; */
  text-align: center;
  color: #808080;
  font-weight: 600;
  font-size: 1.45rem;
  cursor: pointer;
}
.detail-pop-center {
  height: calc(100% - 55px);
  overflow: auto;
}
.detail-pop-content {
  margin: 10px 15px;
  color: #808080;
}
.detail-pop-content-title {
  padding: 2px 15px;
  color: #157cf3;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 7px;
  display: flex;
}
.yuan {
  width: 9px;
  height: 9px;
  background: #157cf3;
  border-radius: 50%;
  margin: auto 6px auto 0;
}
.detail-pop-content-box {
  font-size: 0.85rem;
}
.detail-pop-content-box-col {
  padding: 6px 0;
  word-break: break-all;
}
.file-title {
  font-size: 0.85rem;
  padding: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.mouse-s {
  color: #fff;
}
.img-list {
  width: 65px;
  height: 85px;
  margin-right: 10px;
  cursor: pointer;
}
.img-list1 {
  position: relative;
  width: 65px;
  height: 85px;
  margin-right: 10px;
}
.img-list1:hover .mask {
  opacity: 1;
  cursor: default;
}
.img-list1 > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.mask {
  width: 65px;
  height: 65px;
  font-size: 0.95rem;
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 0;
  opacity: 0;
  background: rgba(4, 20, 41, 0.4);
  border-radius: 4px;
  line-height: 65px;
  /* padding: 24px 0; */
}
.img-span {
  font-size: 0.75rem;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.img-list > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.img-list-box {
  display: flex;
  flex-wrap: wrap;
}
</style>
